import { communitiesInitialState } from "./states";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = communitiesInitialState;

export const fetchCommunitiesAsync = createAsyncThunk(
  "communities/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, communities } = getState();
    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getAllCommunities?index=${communities.index}&limit=${communities.limit}&search=${communities.search}&activated=${communities.filters.approved}&new_community=${communities.filters.new_community}&reported=${communities.filters.reported}`,
        config
      );
      successCallback();
      return {
        communities: response.data.communities,
        totalCount: response.data.totalCommunities
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchCommunitiesForExport = createAsyncThunk(
  "communitiesExport/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, communities } = getState();
    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getAllCommunities?limit=9999999`,
        config
      );
      successCallback();
      return {
        communities: response.data.communities,
        totalCount: response.data.totalCommunities
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

const communitiesSlice = createSlice({
  name: "communities",
  initialState,
  reducers: {
    activated: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.value.findIndex((comm) => comm._id === id);
      if (index !== -1) {
        state.value[index] = {
          ...state.value[index],
          ...newData
        };
      }
    },
    verifier: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.value.findIndex((comm) => comm._id === id);
      if (index !== -1) {
        state.value[index] = {
          ...state.value[index],
          ...newData
        };
      }
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSearchText: (state, action) => {
      state.search = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    clearFilters: (state) => {
      state.filters = {
        approved: null,
        new_community: true,
        reported: false
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCommunitiesAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCommunitiesAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action?.payload?.communities;
      state.totalCount = action?.payload?.totalCount;
    });
    builder.addCase(fetchCommunitiesAsync.rejected, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCommunitiesForExport.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCommunitiesForExport.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action?.payload?.communities;
      state.totalCount = action?.payload?.totalCount;
    });
    builder.addCase(fetchCommunitiesForExport.rejected, (state) => {
      state.isLoading = true;
    });
  }
});

export default communitiesSlice.reducer;
export const {
  verifier,
  activated,
  setIndex,
  setLimit,
  setSearchText,
  setFilters,
  clearFilters
} = communitiesSlice.actions;
